<script setup lang="ts">
import { DocumentIcon } from '@heroicons/vue/24/solid'

const props = defineProps<{
  url: string,
  name: string,
}>()

const fileInfo = await fetch(props.url, { method: 'HEAD' });
const contentType = fileInfo.headers.get("content-type");
const contentSize = Math.round(Number(fileInfo.headers.get("content-length")) / 1024 / 1024 * 100) / 100;
</script>

<template>
  <a :href="url" target="_blank" class="box">
    <img v-if="contentType.startsWith('image/')" :src="url" :alt="name"/>
    <DocumentIcon v-if="contentType === 'application/pdf'" class="pdf"/>
    <div class="break-all">
      {{ name }}
      <span class="opacity-80">({{ contentSize }}&nbsp;MiB)</span>
    </div>
  </a>
</template>

<style scoped lang="scss">
.box {
  @apply flex items-center;
  @apply cursor-pointer rounded-lg border px-5 py-4 transition-colors;
  @apply border-gray-300 dark:border-gray-600;
  @apply hover:border-gray-300 hover:bg-gray-100 hover:dark:border-neutral-700 hover:dark:bg-neutral-800/30;
}

img, .pdf {
  @apply w-24 h-32 rounded-lg mr-3;
}

img {
  @apply object-cover;
}

.pdf {
  @apply opacity-50;
}
</style>
